import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay } from 'swiper/modules';
import { Link } from 'react-router-dom';
import HomeVideo1 from '../assets/images/banner/banner.mp4';
import FeaturedProject from '../component/FeaturedProject';


export default function Home() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="home-page">
            <div className='banner-slider'>

                <Swiper
                    spaceBetween={30}
                    centeredSlides={true}
                    loop={true}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    navigation={false}
                    modules={[Autoplay]}
                    className=" home-slider"
                >
                    <SwiperSlide>
                        <div className='banner-section'>
                            <video className="web-banner" autoPlay muted loop>
                                <source src={HomeVideo1} type="video/mp4" />
                            </video>
                            <div className='banner-overlay'></div>
                            <div className='banner-content padding-left-right'>
                                <div className='banner-badge'>
                                    <span className='banner-badge-dot'></span>
                                    Trusted Cybersecurity Partner in the Region
                                </div>
                                <h1 className='banner-headline'>
                                    Securing Your <span className='banner-highlight'>Digital Future</span><br />
                                    with Intelligence & Precision
                                </h1>
                                <p className='banner-subtext'>
                                    End-to-end cybersecurity solutions powered by global technology partnerships - protecting Enterprise, Government & SMB businesses.
                                </p>
                                <div className='banner-tags'>
                                    {['Managed Security', 'Cloud', 'Email', 'Network', 'Endpoint', 'Data', 'Digital Workspace', 'SOC 24/7', 'MSSP'].map((tag, i) => (
                                        <span key={i} className='banner-tag'>{tag}</span>
                                    ))}
                                </div>
                                <div className='banner-cta-row'>
                                    <Link to="/contact"><button className='banner-btn-primary'>Talk to our Expert <i className="fa fa-arrow-right"></i></button></Link>
                                    <Link to="/about"><button className='banner-btn-secondary'>Discover More</button></Link>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>


                </Swiper>
            </div>

            <section className="home-stats-strip" aria-label="Cloud Mind statistics">
                <div className="home-stats-line" aria-hidden="true"></div>
                <div className="container">
                    <div className="home-stats-grid">
                        <div className="home-stat-item">
                            <strong>8<span>+</span></strong>
                            <p>Years Experience</p>
                        </div>
                        <div className="home-stat-item">
                            <strong>200<span>+</span></strong>
                            <p>Clients Protected</p>
                        </div>
                        <div className="home-stat-item">
                            <strong>50<span>+</span></strong>
                            <p>Technology Partners</p>
                        </div>
                        <div className="home-stat-item">
                            <strong className="home-stat-time">24/7</strong>
                            <p>SOC Monitoring</p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="discover-section padding-left-right top bottom" style={{ overflow: 'hidden', dataColor: "#000" }}>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 order_2 wow  slideInLeft" >
                            <div class="left-section mousemoveBox" style={{ position: 'relative' }}>
                                <img src={require('../assets/images/home/about-company.webp')} alt="discover" />
                                <div class="experience-section">
                                    <h4>8+</h4>
                                    <h6>
                                        YEARS EXPERIENCE</h6>
                                </div>

                            </div>

                        </div>
                        <div class="col-lg-6 order_1">
                            <div class="right-section-discover-b">
                                <div class="right-section-discover">
                                    <div className='content-badge wow fadeInUp' style={{ marginBottom: '16px' }}>
                                        <span className='badge-text'>About Us</span>
                                    </div>
                                    <h2 class="sub-heading text-white">Welcome to <span style={{ color: '#ff6b35' }}>CLOUD MIND</span>
                                    </h2>
                                    <p class="mb-3 para_text1">
                                        Along with changing and disrupting market demand and requirement of Information technology in the fast-growing market, Security has become one of the finest needs for all businesses.
                                    </p>
                                    <p class="mb-3 para_text1">
                                        CLOUD MIND is one of the leading solution providers in the region with a customer-centric approach. We deliver advanced cyber security solutions through partnerships with global technology vendors &mdash; protecting Enterprise, Government, and SMB businesses.
                                    </p>
                                    <p class="mb-3 para_text1">
                                        We lead from bottom to top. With exceptional technical knowledge, our expertise designs and executes projects in the most effective and efficient manner, empowering businesses by eliminating risk and streamlining operations.
                                    </p>

                                    <div className='button_call' style={{ marginTop: '28px' }}>
                                        <Link to="/about"><button>Read More <i className="fa fa-arrow-right"></i></button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={require('../assets/images/pattern.png')} alt="pattern" class="pattern" />
            </section>

            <div className='ransomeware-section top bottom'>
                <div className='container'>
                    <div className='row align-items-center g-4'>
                        <div className='col-lg-6 col-md-12'>
                            <div className='ransomeware-content'>
                                <div className='content-badge wow fadeInUp'>
                                    <span className='badge-text'>Security Solution</span>
                                </div>
                                <h2 className='section-main-heading wow fadeInUp text-white'>Stop ransomware in its tracks</h2>
                                <p className='section-description wow fadeInUp'>
                                    Ransomware is an ever-evolving form of malware designed to encrypt files on a device, rendering any files and the systems that rely on them unusable. Malicious actors then demand ransom in exchange for decryption. Ransomware actors often target and threaten to sell or leak exfiltrated data or authentication information if the ransom is not paid.
                                </p>
                                <p className='section-description wow fadeInUp' style={{ marginTop: '15px' }}>
                                    Cloud Mind partnered with world's top notch security companies to provide robust solution to stop ransomware.
                                </p>
                                <div className='feature-highlights mt-4'>
                                    <div className='feature-item wow fadeInUp'>
                                        <div className='feature-icon'>
                                            <i className="fa fa-shield-alt"></i>
                                        </div>
                                        <div className='feature-text'>
                                            <h4>Multi-Layer Protection</h4>
                                            <p>Advanced defense mechanisms</p>
                                        </div>
                                    </div>
                                    <div className='feature-item wow fadeInUp'>
                                        <div className='feature-icon'>
                                            <i className="fa fa-clock"></i>
                                        </div>
                                        <div className='feature-text'>
                                            <h4>24/7 Monitoring</h4>
                                            <p>Real-time threat detection</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='button_call mt-4'>
                                    <Link to="/email"><button>View Details <i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-12'>
                            <div className='section-image-container wow fadeInRight'>
                                <div className='image-wrapper'>
                                    <div className='floating-card card-1'>
                                        <div className='card-icon'>
                                            <i className="fa fa-lock"></i>
                                        </div>
                                        <div className='card-content'>
                                            <h5>Encrypted</h5>
                                            <p>Files Protected</p>
                                        </div>
                                    </div>
                                    <div className='floating-card card-2'>
                                        <div className='card-icon danger'>
                                            <i className="fa fa-exclamation-triangle"></i>
                                        </div>
                                        <div className='card-content'>
                                            <h5>Threats Blocked</h5>
                                            <p>99.9% Success</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='data_drive-section top bottom'>
                <div className='container'>
                    <div className='row align-items-center g-4'>
                        <div className='col-lg-6 col-md-12 order-md-2'>
                            <div className='data_drive-content'>
                                <div className='content-badge wow fadeInUp'>
                                    <span className='badge-text'>Analytics & Insights</span>
                                </div>
                                <h2 className='section-main-heading wow fadeInUp'>Data Driven Decision Making</h2>
                                <p className='section-description wow fadeInUp'>
                                    Data-driven decision making is an approach to making informed choices and solving problems based on the analysis of relevant data. It involves collecting, organizing, and analyzing data to gain insights and guide decision-making processes.
                                </p>
                                <p className='section-description wow fadeInUp' style={{ marginTop: '15px' }}>
                                    It's important to note that data-driven decision making is not a one-size-fits-all approach. It should be complemented by human judgment, domain expertise, and consideration of ethical implications to ensure responsible and effective decision making.
                                </p>
                                <div className='feature-highlights mt-4'>
                                    <div className='feature-item wow fadeInUp'>
                                        <div className='feature-icon'>
                                            <i className="fa fa-chart-line"></i>
                                        </div>
                                        <div className='feature-text'>
                                            <h4>Real-Time Analytics</h4>
                                            <p>Instant data insights</p>
                                        </div>
                                    </div>
                                    <div className='feature-item wow fadeInUp'>
                                        <div className='feature-icon'>
                                            <i className="fa fa-brain"></i>
                                        </div>
                                        <div className='feature-text'>
                                            <h4>AI-Powered Decisions</h4>
                                            <p>Smart business intelligence</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='button_call mt-4'>
                                    <Link to="/email"><button>View Details <i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-12 order-md-1'>
                            <div className='section-image-container wow fadeInLeft'>
                                <div className='image-wrapper'>
                                    <div className='floating-card card-1'>
                                        <div className='card-icon'>
                                            <i className="fa fa-database"></i>
                                        </div>
                                        <div className='card-content'>
                                            <h5>Data Sources</h5>
                                            <p>Multiple Integrations</p>
                                        </div>
                                    </div>
                                    <div className='floating-card card-2'>
                                        <div className='card-icon success'>
                                            <i className="fa fa-check-circle"></i>
                                        </div>
                                        <div className='card-content'>
                                            <h5>Accuracy Rate</h5>
                                            <p>95%+ Precision</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* <div className='machines-section top bottom'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7'>
                            <div className='data_drive-content'>
                                <h2 className='heading wow fadeInUp'>Machines Fight Back</h2>
                                <p className='para_text1 wow fadeInUp'>
                                    You work hard to protect your business from the ever-changing landscape of cyber-attacks. And yet, no matter what you do, it never seems to be enough.
                                    That's where cyber security defense goes next- gen. Cloud Mind has partnered a futuristic and revolutionary response system that continuously monitors
                                    your network and alerts you to any new threats, before they have a chance to impact your business.
                                </p>
                                <div className='button_call'>
                                    <Link to="/machine-fight-back"><button>View More <i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-5'>

                        </div>
                    </div>
                </div>
            </div> */}


            <div className="blog-wrapper">
                <div className="container">
                    <div className="row align-items-center g-0">
                        <div className="col-lg-6 blog-content">
                            <div className="blog-content-inner">
                                <div className="blog-tag-row">
                                    <span className="blog-tag-pill">
                                        <i className="fa fa-robot"></i> AI Defense
                                    </span>
                                    <span className="blog-tag-date">Updated 12 Sep 2025</span>
                                </div>
                                <p className="blog-category">Machines Fight Back</p>
                                <p className="blog-title">
                                    You work hard to protect your business from the ever-changing landscape of cyber-attacks. And yet, no matter what you do, it never seems to be enough.
                                </p>
                                <p className="blog-subtitle">
                                    That's where cyber security defense goes next-gen. Cloud Mind has partnered a futuristic and revolutionary response system that continuously monitors your network and alerts you to any new threats - before they impact your business.
                                </p>
                                <div className="blog-stats-row">
                                    <div className="blog-stat">
                                        <span className="blog-stat-num">99.9%</span>
                                        <span className="blog-stat-label">Threat Detection</span>
                                    </div>
                                    <div className="blog-stat-divider"></div>
                                    <div className="blog-stat">
                                        <span className="blog-stat-num">24/7</span>
                                        <span className="blog-stat-label">Network Monitoring</span>
                                    </div>
                                    <div className="blog-stat-divider"></div>
                                    <div className="blog-stat">
                                        <span className="blog-stat-num">&lt;1min</span>
                                        <span className="blog-stat-label">Response Time</span>
                                    </div>
                                </div>
                                <div className="button_call mt-4">
                                    <Link to="/machine-fight-back"><button>Learn More <i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 blog-image-col">
                            <div className="blog-image-wrap">
                                <img
                                    src="https://www.q3tech.com/wp-content/uploads/2025/09/Hyper-Personalization-Benefits-Use-Cases.jpg"
                                    alt="Machines Fight Back"
                                    className="blog-image"
                                />
                                <div className="blog-image-badge">
                                    <i className="fa fa-shield-alt"></i>
                                    <span>AI-Powered Security</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="bottom hm-our-solution ConsultingIndustry" style={{ backgroundColor: '#000000' }}>
                <div class="container">
                    <div className='container top'>
                        <div class="title mb-3 mb-md-5">
                            <div className='sub-heading-text'>
                                <h2 className='text-center text-white'>Industries We Serve</h2>
                                <div class="divider-wrapper small"></div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/healthcare.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Healthcare</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/banking.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Banking</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/travel.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Travel</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/manufaturing.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Manufacturing</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/retail.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Retail</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/education.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Education</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/real-estate.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Real Estate</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/transptation.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Transportation</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/telecom.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Telecom</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/social.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Media & Advertising</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/agriculture.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Agriculture</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-4">
                                <div class="industries-serve">
                                    <img src={require('../assets/images/industries/govt.webp')} alt="" />
                                    <div class="image-text">
                                        <p>Government</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className='security-program-section bottom'>
                <div className='container'>
                    <div className='sub-heading-text'>
                        <h2 className='text-center text-white'>Boost Your Cyber Security Advancements</h2>
                        <div class="divider-wrapper small"></div>
                    </div>
                    <div className='row mt-4 g-4'>
                        <div className='col-lg-3 col-md-6'>
                            <div className='advancements'>
                                <div className='adv-icon'>
                                    <i className="fa fa-network-wired"></i>
                                </div>
                                <h3>Network and Infrastructure Security</h3>
                                <p>Technical Assurance Services for a Secure Cloud Computing Transition</p>
                                <Link to="/enterprise-network-ndr" className='adv-link'>
                                    Explore <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6'>
                            <div className='advancements'>
                                <div className='adv-icon'>
                                    <i className="fa fa-cloud"></i>
                                </div>
                                <h3>Cloud Security</h3>
                                <p>Industrial Control Systems Security to protect Critical Infrastructure</p>
                                <Link to="/cloud" className='adv-link'>
                                    Explore <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6'>
                            <div className='advancements'>
                                <div className='adv-icon'>
                                    <i className="fa fa-industry"></i>
                                </div>
                                <h3>ICS/OT Security</h3>
                                <p>Hunting Cyber Adversaries with SOC as a Service by CLOUD MIND</p>
                                <Link to="/ics-security" className='adv-link'>
                                    Explore <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6'>
                            <div className='advancements'>
                                <div className='adv-icon'>
                                    <i className="fa fa-shield-alt"></i>
                                </div>
                                <h3>24x7 Managed CSOC and MDR</h3>
                                <p>Advanced Next Generation Enterprise Network Security</p>
                                <Link to="/mdr" className='adv-link'>
                                    Explore <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='achievement-section top bottom'>
                <div className='sub-heading-text'>
                    <h2 className='text-center text-white'>Our Technology Partners</h2>
                    <div class="divider-wrapper small"></div>
                </div>
                <div className='container'>
                    <div className='image-slider'>

                        <Swiper
                            slidesPerView={2.6}
                            spaceBetween={0}
                            navigation={false}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 0,
                                },
                                768: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 0,
                                },
                                1024: {
                                    slidesPerView: 5,
                                    spaceBetween: 0,
                                },
                                1444: {
                                    slidesPerView: 5,
                                    spaceBetween: 0,
                                },
                            }}

                            modules={[Autoplay]}

                            className="iconSwiper"
                        >
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-1.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-2.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-3.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-4.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-5.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/netskope.png')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-6.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-7.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-8.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-9.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-10.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-11.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-12.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-13.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-14.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-15.webp')} alt='' />
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className='award_item'>
                                    <img src={require('../assets/images/partner/partner-16.webp')} alt='' />
                                </div>
                            </SwiperSlide>

                        </Swiper>
                    </div>
                </div>
            </section>

            <div className='services-section'>
                <div class="container">
                    <div class="title mb-4 mb-lg-5">
                        <div className='sub-heading-text'>
                            <h2 className='text-center text-white'>Related Services</h2>
                            <div class="divider-wrapper small"></div>
                        </div>
                    </div>
                    <div className="related-services-grid">
                        {[
                            {
                                number: '01', path: '/empower-employee', image: require('../assets/images/cyber-security-banner.jpg'),
                                title: 'Empower the Employee by Cyber Training',
                                text: 'Cybersecurity is the most important issue facing organizations today. With the emergence of ransomware and other cyberattacks, the need for tailored training to help employees protect themselves, their data, and their networks is clear. The good news is that many technologies and solutions are available to help you. But choosing the perfect fit for your organization can be tough. So, why not let our experts help you?'
                            },
                            {
                                number: '02', path: '/email', image: require('../assets/images/services/products/email-froud.jpg'),
                                title: 'Stopping Sophisticated Email Attacks',
                                text: "Stopping sophisticated email attacks requires a multi-layered approach that combines technological solutions, user education, and strong security practices. Keep your people safe & secure. In a world of email and cloud threats, your company's people are at risk. Our products are designed to protect them from security vulnerabilities, malware-laden emails, phishing scams, and more."
                            },
                            {
                                number: '03', path: '/digital-risk', image: require('../assets/images/services/products/Content Monitoring- Digital Risk.jpg'),
                                title: 'Protecting Digital Risk',
                                text: "Digital Risk Protection is a comprehensive security solution that provides digital risk management for your brand and customers. It's the only solution for all digital engagement channels, including web domains, social media, and the deep and dark web. It revolutionises the digital risk management industry by providing you a holistic defence."
                            },
                            {
                                number: '04', path: '/digital-workforce', image: require('../assets/images/services/technology/ai-bg.jpg'),
                                title: 'Digital Workforce Protection, No Matter',
                                text: 'Self-Learning AI is today capable of making decisions and taking proportionate, autonomous actions to thwart in-progress attacks. In a world where attackers are using AI to find vulnerabilities and creating deep fakes to fool humans, the ability for machines to augment humans - and even fight back - is now a necessity.'
                            }
                        ].map(service => (
                            <Link className="related-service-card" to={service.path} key={service.number} aria-label={`View ${service.title}`}>
                                <img src={service.image} alt="" aria-hidden="true" />
                                <span className="related-service-shade" aria-hidden="true"></span>
                                <span className="related-service-number">{service.number}</span>
                                <div className="related-service-content">
                                    <h3>{service.title}</h3>
                                    <p>{service.text}</p>
                                    <span className="related-service-action">View Details <i className="fa fa-arrow-right"></i></span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>

            {/* <FeaturedProject /> */}

            <section className="steps-two style-two work-process-section">
                <div className="container">
                    <div className="work-process-heading">
                        <span>Our process</span>
                        <h2>How We Work</h2>
                        <p>A clear, collaborative approach that turns your technology goals into secure, reliable results.</p>
                    </div>
                    <div className="row clearfix align-items-center">
                        <div className="steps-two_content-column col-lg-6 col-md-12 col-sm-12">
                            <div className="steps-two_content-inner">
                                <div className="sec-title">
                                    <h3 className="sec-title_heading">Smart strategy. Excellent execution.</h3>
                                    <p className="work-process-intro">Choose a service, meet our experts, and receive a solution designed around your business.</p>
                                </div>
                                <div className="step-two_block">
                                    <div className="step-two_block-inner">
                                        <span className="step-two_block-icon flaticon-idea"></span>
                                        <h4 className="step-two_block-title">Trusted expertise</h4>
                                        <p>Proven IT solutions delivered with transparency, accountability, and a focus on measurable results.</p>
                                    </div>
                                </div>
                                <div className="step-two_block">
                                    <div className="step-two_block-inner">
                                        <span className="step-two_block-icon flaticon-lamp"></span>
                                        <h4 className="step-two_block-title">24/7 support</h4>
                                        <p>Responsive, end-to-end assistance that keeps your critical systems protected and available.</p>
                                    </div>
                                </div>
                                <div className="step-two_block">
                                    <div className="step-two_block-inner">
                                        <span className="step-two_block-icon flaticon-cloud"></span>
                                        <h4 className="step-two_block-title">Client-first delivery</h4>
                                        <p>Every engagement is built around your goals, timelines, and long-term success.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="steps-two_image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="work-process-visual">
                                <div className="steps-two_image work-process-main-image">
                                    <img src={require('../assets/images/home/work-1.webp')} alt="CloudMind experts planning a secure technology solution" />
                                </div>
                                <div className="steps-two_image work-process-small-image">
                                    <img src={require('../assets/images/home/work-2.webp')} alt="Digital security partnership" />
                                </div>
                                <div className="work-process-stat"><strong>24/7</strong><span>Expert support</span></div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className='testimonial-section bottom top padding-left-right'>
                <div className='text-center mb-5'>
                    <h2 className='heading wow fadeInUp'>TESTIMONIALS</h2>
                    <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '15px', marginTop: '10px' }}>What our clients say about us</p>
                </div>
                <Swiper
                    spaceBetween={28}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        0: { slidesPerView: 1, spaceBetween: 16 },
                        640: { slidesPerView: 1, spaceBetween: 20 },
                        768: { slidesPerView: 2, spaceBetween: 24 },
                        1024: { slidesPerView: 2, spaceBetween: 28 },
                        1440: { slidesPerView: 3, spaceBetween: 28 },
                    }}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    modules={[Pagination, Autoplay]}
                    className="testimonialSwiper"
                >
                    {[
                        {
                            quote: "CLOUD MIND has been a game changer for our cybersecurity strategy. Their comprehensive protection across our email, cloud, and network systems has kept our data secure from evolving threats. Their proactive approach has given us peace of mind.",
                            name: "IT Director",
                            role: "Manufacturing Industry",
                            initial: "I"
                        },
                        {
                            quote: "We turned to CLOUD MIND for a complete overhaul of our cybersecurity protocols, and it was the best decision we made. Their expert team implemented robust security measures making us feel protected against even the most sophisticated cyberattacks.",
                            name: "Chief Information Security Officer",
                            role: "Manufacturing Industry",
                            initial: "C"
                        },
                        {
                            quote: "CLOUD MIND's email security and network defense solutions have been critical in preventing cyber threats. They are incredibly responsive and always available. We've seen a significant reduction in phishing attempts and other security breaches.",
                            name: "Operations Manager",
                            role: "Agriculture Industry",
                            initial: "O"
                        },
                        {
                            quote: "Since partnering with CLOUD MIND, our network and cloud systems have been fortified with state-of-the-art security protocols. They secured our cloud storage, ensuring compliance and protecting our clients' data.",
                            name: "Founder",
                            role: "Healthcare Industry",
                            initial: "F"
                        },
                        {
                            quote: "CLOUD MIND has delivered unmatched expertise in securing our cloud services and networks. Their end-to-end solutions, from email filtering to advanced network monitoring, have helped us prevent data breaches and avoid costly downtime.",
                            name: "Chief Technology Officer",
                            role: "Real Estate Industry",
                            initial: "C"
                        },
                        {
                            quote: "The cybersecurity solutions provided by CLOUD MIND have given us a level of confidence we didn't have before. Their services cover everything from email threat prevention to securing our cloud and network infrastructure.",
                            name: "Head of Technology",
                            role: "Transportation Industry",
                            initial: "H"
                        },
                    ].map((t, i) => (
                        <SwiperSlide key={i}>
                            <div className='slider_container'>
                                <div className='slider_3'>
                                    <div className='testimonial-stars'>
                                        {[...Array(5)].map((_, si) => (
                                            <i key={si} className="fa fa-star" style={{ color: '#ff6b35', fontSize: '13px', marginRight: '3px' }}></i>
                                        ))}
                                    </div>
                                    <div className='slider-para'>"{t.quote}"</div>
                                    <div className='testimonial-footer'>
                                        <div className='testimonial-avatar'>{t.initial}</div>
                                        <div>
                                            <h6>{t.name}</h6>
                                            <span className='role-label'>{t.role}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>

            <section id="latest-news" className='new-section top bottom latest-news-section'>
                <div className='container'>
                    <div className='sub-heading-text latest-news-heading'>
                        <h2 className='text-center text-white'>Latest News & Blogs</h2>
                        <div className="divider-wrapper small"></div>
                    </div>
                    <div className='row latest-news-grid'>
                        <div className='col-lg-4 col-md-6'>
                            <Link to="/blog/cybersecurity-trends" className='latest-news-card' aria-label="Read The Latest Trends in Cybersecurity">
                                <img src={require('../assets/images/blog/blog-1.webp')} alt='Digital city technology visualization' />
                                <div className='latest-news-overlay'>
                                    <div className='latest-news-content'>
                                        <h3>The Latest Trends in Cybersecurity: How to Protect Your Business</h3>
                                        <span className='latest-news-link'>Read article <i className="fa fa-arrow-right" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <Link to="/blog/ai-in-cybersecurity" className='latest-news-card' aria-label="Read The Present State of Artificial Intelligence in Cybersecurity">
                                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStYKngbLOMofXQXHT65-tO1epGrUSqUglOOIWsRr-TzeEeIdIPHsMT2LM&s=10" alt='Cybersecurity network across modern buildings' />
                                <div className='latest-news-overlay'>
                                    <div className='latest-news-content'>
                                        <h3>The Present State of Artificial Intelligence in Cybersecurity</h3>
                                        <span className='latest-news-link'>Read article <i className="fa fa-arrow-right" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <Link to="/blog/cybersecurity-excellence" className='latest-news-card' aria-label="Read Building a Culture of Cybersecurity Excellence">
                                <img src="https://innefu.com/wp-content/uploads/2025/05/HOW-CYBER-SECURITY-IMPACTS-BUSINESSES-GLOBALLY-1024x576.webp" alt='Artificial intelligence technology concept' />
                                <div className='latest-news-overlay'>
                                    <div className='latest-news-content'>
                                        <h3>Building a Culture of Cybersecurity Excellence</h3>
                                        <span className='latest-news-link'>Read article <i className="fa fa-arrow-right" aria-hidden="true"></i></span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}
